<adaa-data-table
    #adaaDataTable
    apiName="getLookupList"
    [titleHeader]="'lookup.management.title' | translate"
    [configKey]="constants.MAIN_TABLE_LIST_CONF_KEY.LOOKUPMANAGER"
    [itemTypeId]="constants.CONSTANT_PERMISSIONS.LOOKUP_MANAGEMENT"
    [paramsString]="'itemType=67'"
    [enableAdd]="false"
    [enableEditAction]="true"
    [enableDeleteAction]="true"
    [enableViewAction]="true"
    [enableAdd]="false"
    [enableViewAction]="false"
    [enableDeleteAction]="false"
    (actionClicked)="getAction($event)"
></adaa-data-table>
